let msalInstance = null;

// Set the MSAL instance (called once from index.js)
export const setMsalInstance = (instance) => {
  msalInstance = instance;
};

// Get a fresh access token silently (handles refresh automatically)
export const getAccessToken = async () => {
  if (!msalInstance) return sessionStorage.getItem('userToken') || null;

  const isSupplier = sessionStorage.getItem('user_type') === 'supplier';

  try {
    if (isSupplier) {
      const supplierToken = sessionStorage.getItem('userToken') || null;
      
      // Check if supplier token is blacklisted
      if (supplierToken) {
        const { tokenInvalidationService } = await import('./tokenInvalidationService');
        if (tokenInvalidationService.isTokenBlacklisted(supplierToken)) {
          console.warn('[TokenManager] Supplier token is blacklisted');
          sessionStorage.removeItem('userToken');
          return null;
        }
      }
      
      return supplierToken;
    }

    // Azure AD: acquire token silently (MSAL handles refresh)
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      return sessionStorage.getItem('userToken') || null;
    }

    const response = await msalInstance.acquireTokenSilent({
      scopes: ['User.Read'],
      account: accounts[0],
    });

    // Update sessionStorage with fresh token and check blacklist
    if (response.accessToken) {
      const { tokenInvalidationService } = await import('./tokenInvalidationService');
      
      if (tokenInvalidationService.isTokenBlacklisted(response.accessToken)) {
        console.warn('[TokenManager] Fresh token is blacklisted');
        return null;
      }
      
      sessionStorage.setItem('userToken', response.accessToken);
    }

    return response.accessToken;
  } catch (error) {
    console.warn('[TokenManager] Silent token acquisition failed:', error.message);

    // If interaction required, trigger redirect
    if (error.name === 'InteractionRequiredAuthError') {
      try {
        await msalInstance.acquireTokenRedirect({
          scopes: ['User.Read'],
          account: msalInstance.getAllAccounts()[0],
        });
      } catch (redirectError) {
        console.error('[TokenManager] Token redirect failed:', redirectError);
      }
      return null;
    }

    return sessionStorage.getItem('userToken') || null;
  }
};
